import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";

const styles = 'styles.css?ver=1.1';

const theme = {
  fontFamily: "var(--secondary-font)",
  fontMono: "Roboto Mono, sans-serif",
  baseFontSize: "17",
  msRatio: "1.15",

  background: "var(--pozadi-webu)",
  textColor: "var(--text-barva)",
  codeColor: "var(--kod-block-barva-text)",
  linkColor: "var(--text-odkaz-barva)",
  
  lightColor: "#ffffff",
  
  pageHeadingBackground: "var(--horni-pruh-barva-pozadi)",
  pageHeadingHeight: 170,
 
  navBarBackground: "var(--dolni-pruh-barva-pozadi)",
  navBarTextColor: "var(--brand-barva)",
  
  brandColor: "var(--brand-barva)",

  sidebarColor: "var(--sidebar-barva)",
  sidebarColorText: "var(--sidebar-barva-text)",
  sidebarColorTextActive: "var(--sidebar-barva-text-aktivni)",
  sidebarColorLine: "var(--sidebar-barva-linky)",
  sidebarColorHeading: "var(--sidebar-barva-nadpis)",
  
  bgLight: "var(--text-block-light-barva-pozadi)",
  bgDark: "var(--text-block-dark-barva-pozadi)",
  };

  const pages = [
    {
      path: '/',
      title: 'VisualBook',
      content: pageLoader(() => import('./uvod.md'))
    },
    {
      title: 'Logo',
      pages: [
    {
      path: '/vertikalni-logo-profifp',
      title: 'Vertikální logo',
      content: pageLoader(() => import('./vertikalni-logo-profifp.md'))
    },
    {
      path: '/horizontalni-logo-profifp',
      title: 'Horizontální logo',
      content: pageLoader(() => import('./horizontalni-logo-profifp.md'))
    },
    {
      path: '/symbol-loga-profifp',
      title: 'Symbol loga',
      content: pageLoader(() => import('./symbol-profifp.md'))
    },
    {
      path: '/jednobarevne-logo',
      title: 'Jednobarevné logo',
      content: pageLoader(() => import('./jednobarevne-logo.md'))
    },
    {
      path: '/formaty-loga',
      title: 'Výběr formátu loga',
      content: pageLoader(() => import('./formaty-loga.md'))
    },
  ]
},
  {
    path: '/barvy',
    title: 'Barvy',
    content: pageLoader(() => import('./barvy.md'))
  },
  {
    path: '/pismo',
    title: 'Písmo',
    content: pageLoader(() => import('./pismo.md'))
  },
  {
    path: '/nazvy',
    title: 'Názvy',
    content: pageLoader(() => import('./nazvy.md'))
  },
  {
    path: '/grafika-ke-stazeni',
    title: 'Grafika ke stažení',
    content: pageLoader(() => import('./grafika-ke-stazeni.md'))
  },
  ]
  

ReactDOM.render(
  <Catalog title="ProfiFP VisualBook" logoSrc="profifp-logo.svg" styles={styles} theme={theme} pages={pages} />,
  document.getElementById("catalog")
);


// WEBPACK FOOTER //
// ./catalog/index.js